<template>
    <div class="content-header px-md-5 head-check">
        <div v-if="currentCustomer != 0">
            <a class="me-1 pb-1" :href="routeCustomerFile" target="_blank">
                <!--<img
                    v-if="currentCustomer.image"
                    class="img-avatar img-avatar48"
                    style="width: 34px; height: 34px"
                    :src="currentCustomer.image"
                    alt=""
                /> -->
            </a>
            <span class="ppv2-text-black poppinsMedium fs-6 text-capitalize pb-1" href="javascript:void(0)"
                >{{ currentCustomer.first_name }} {{ currentCustomer.last_name }}</span
            >
        </div>

        <!-- <button class="btn btn-sm btn-alt-success">Offrir<i class="fa fa-fw fa-gift"></i></button> -->
        <!-- <button
                role="button"
                type="button"
                class="ms-auto btn btn-sm btn-alt-info"
                data-bs-toggle="modal"
                data-bs-target="#modal-custom-discount"
            >
                Remise personnalisée
            </button> -->
        <!--<button
            role="button"
            v-if="currentCustomer"
            type="button"
            class="ms-auto btn fs-sm btn-dark py-2 px-4 rounded-8 fw-medium"
            @click="
                () => {
                    $emit('show-iframe', currentCustomer.id)
                }
            "
        >
            Ajouter carte compte client
            <v-icon color="#fff " size="20px ">mdi-credit-card-outline</v-icon>
        </button>-->
    </div>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
    props: ['currentCustomer', 'routeCustomerFile'],

    computed: {
        ...get('overlay@data', {
            c_customDiscount: 'customDiscount',
        }),
    },
}
</script>
<style scoped>
.border-name {
    border-bottom: solid 1px #7d2dbd;
    padding-right: 107px;
}
</style>
